module.exports = "/_next/static/videos/ZONE-227c26b263c98d0ab8e027036cd7bcc2.mp4";